// src/Gallery.jsx
import React, { useContext, useState, useEffect } from "react";
import { GlobalContext } from "./components/GlobalContext";

function Gallery() {
  const {
    heroImg,
    appstoreImg,
    googleplayImg,
    logo,
    mainImg,
    whatsappImgs,
    valuesImg,
    portfolioImgs,
  } = useContext(GlobalContext);

  const [customImages, setCustomImages] = useState([]);

  useEffect(() => {
    // مثال: نقدر نضيف أي صورة جديدة هنا مباشرة
    const allImages = [
      heroImg,
      appstoreImg,
      googleplayImg,
      logo,
      mainImg,
      valuesImg,
      ...whatsappImgs,
      ...portfolioImgs,
      // ممكن تضيف أي URL خارجية كمان
      "https://images.unsplash.com/photo-1522202176988-66273c2fd55f",
      "https://images.unsplash.com/photo-1503023345310-bd7c1de61c7d",
    ];

    // إزالة أي قيم فارغة
    setCustomImages(allImages.filter(img => img));
  }, [
    heroImg,
    appstoreImg,
    googleplayImg,
    logo,
    mainImg,
    whatsappImgs,
    valuesImg,
    portfolioImgs,
  ]);

  return (
    <div style={{ padding: "2rem" }}>
      <h1 style={{ textAlign: "center", marginBottom: "2rem" }}>معرض الصور</h1>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
          gap: "1rem",
        }}
      >
        {customImages.map((img, i) => (
          <div key={i} style={{ border: "1px solid #ccc", padding: "5px" }}>
            <img
              src={img}
              alt={`custom-${i}`}
              style={{ width: "100%", height: "auto", display: "block" }}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Gallery;
